// extracted by mini-css-extract-plugin
export default {"root":"BusinessTemplates__root--2w5TA","head":"BusinessTemplates__head--1wIs9","subhead":"BusinessTemplates__subhead--WtI7f","main":"BusinessTemplates__main--2WsGX"};